import { useState, useEffect } from 'react';
import { render } from 'react-dom';
const $ = jQuery;
import 'swiper/css/bundle'; // Swiper CSS

import { useWPAjax } from '../../react-utils/hooks';

import DisplayPosts from './Components/Frontend/DisplayPosts';
import Pagination from './Pagination';
import './style.scss';
import { sliderConfig, setSliderHeight, tickerConfig } from './utils/configs';

// Advanced Posts Block
document.addEventListener('DOMContentLoaded', () => {
	const postsEls = document.querySelectorAll('.wp-block-ap-block-posts');
	postsEls.forEach(postEl => {
		const nonce = JSON.parse(postEl.dataset.nonce);
		const attributes = JSON.parse(postEl.dataset.attributes);
		const { totalPosts } = JSON.parse(postEl.dataset.extra);
		const { layout } = attributes;

		// Slider
		if ('slider' === layout) {
			const sliderEl = document.querySelector(`#${postEl.id} .apbSliderPosts`);

			if (sliderEl) {
				new Swiper(sliderEl, sliderConfig(attributes));
				// new Swiper(sliderEl, {
				// 	...sliderConfig(attributes),
				// 	on: {
				// 		init: () => {
				// 			const slideWrapperEl = document.querySelector(`#${postEl.id} .apbSliderPosts .swiper-wrapper`);
				// 			slideWrapperEl.className = 'swiper-wrapper';
				// 			slideWrapperEl.style.gap = 0;
				// 		}
				// 	}
				// });

				setSliderHeight(`${postEl.id}`);
			}
		} else if ('ticker' === layout) {
			const tickerEl = document.querySelector(`#${postEl.id} .apbTickerPosts`);

			tickerEl && $(tickerEl).easyTicker(tickerConfig(attributes));
		} else {
			render(<RenderMain nonce={nonce} totalPosts={totalPosts} attributes={attributes} />, document.querySelector(`#${postEl.id} .apbPostsMain`));
		}

		postEl?.removeAttribute('data-posts');
		postEl?.removeAttribute('data-attributes');
		postEl?.removeAttribute('data-extra');
	});
});

const RenderMain = ({ nonce, totalPosts, attributes }) => {
	const { cId, layout, postType, selectedTaxonomies = {}, selectedCategories, selectedTags = [], isPostsPerPageAll, postsPerPage, postsOrderBy, postsOrder, postsOffset = 0, postsInclude = [], postsExclude = [], isExcludeCurrent, fImgSize = 'full', metaDateFormat = 'M j, Y' } = attributes;

	const [pageNumber, setPageNumber] = useState('masonry' === layout ? 1 : 0);

	const queryAttr = { postType, selectedTaxonomies, selectedCategories, selectedTags, isPostsPerPageAll, postsPerPage, postsOrderBy, postsOrder, postsOffset, postsInclude, postsExclude, isExcludeCurrent, fImgSize, metaDateFormat }
	const { data = null, saveData } = useWPAjax('apbPosts', { _wpnonce: nonce, queryAttr, pageNumber });

	const [posts, setPosts] = useState([]);
	const isRenderPosts = posts?.length && pageNumber;

	// Remove PHP posts if has posts
	useEffect(() => {
		if (isRenderPosts) {
			document.querySelector(`#apbAdvancedPosts-${cId} .apbPostsMainPH`)?.remove();
		}
	}, [posts, pageNumber]);

	useEffect(() => {
		if (pageNumber) {
			saveData({ pageNumber });
		}
	}, [pageNumber]);

	useEffect(() => {
		if (data) {
			setPosts(data);
		}
	}, [data]);

	return <>
		{isRenderPosts ? <DisplayPosts posts={posts} attributes={attributes} clientId={cId} /> : null}

		<Pagination attributes={attributes} totalCount={totalPosts} onChange={val => {
			// window.scrollTo({
			// 	top: postEl.offsetTop,
			// 	behavior: 'smooth',
			// });

			setPageNumber(val)
		}} />
	</>
}